import mapIcon from "common/icons/map";
import rs2 from "common/icons/startup/rs2.gif";
import rs3 from "common/icons/startup/rs3.jpg";
import rs4 from "common/icons/startup/rs4.jpg";
import rs5 from "common/icons/startup/rs5.jpg";
import startup from "common/icons/startup1.png";
import startup2 from "common/icons/startup2.svg";
import { useState } from "react";

const Startups_Projects = () => {
  const [activeAccordion, setActiveAccordion] = useState(null);

  const startups = [
    {
      id: 1,
      name: "Co-founded RadioSherpa in 2006, pioneering a cloud-edge hybrid solution to aggregate real-time HD Radio metadata and display it in an innovative tiled interface, predating similar designs used by platforms like Netflix.",
      logo: startup2,
      alt: "Radio Sherpa Logo",
      imagess: [rs2, rs3],
      description:
        "In 2006, I co-founded, RadioSherpa, with Sasha Javid, in Boston. Our idea was to offer an electronic programming guide for terrestrial radio stations in the USA. We developed one of the first (in 2006) cloud-edge hybrid solution which aggregated metadata such as song/program titles from HD Radio broadcasts and presented them in real time on a website. The edge solution collected program data directly from tuners deployed in different parts of the country. Below is a screen cap of what the display looked like. Our tiled display predated similar displays now prevalent on iPad sites (we developed this in 2006), and even Netflix..",
      details:
        "We deployed our solution in Boston, New York and San Francisco. In 2008, we sold our company to Google-ventures and Sequoia-backed RadioTime, which today operates under the name of TuneIn. Bill Moore and his team at TuneIn have done a remarkable job, particularly in mobile. Currently TuneIn has more than 40 million monthly active listeners.",
      images: [rs4, rs5],
    },
    {
      id: 2,
      name: "In 2015, I co-founded DataGlen in Bengaluru, initially as a data marketplace before pivoting to machine learning and IoT solutions for managing Distributed Energy Resources like solar and storage.",
      logo: startup,
      alt: "DataGlen Logo",
      description:
        "In 2015, I co-founded DataGlen, with Rajesh Kunnath, Sunil Ghai, and Tanuja Ganu, in Bengaluru. We started with the objective of developing a data marketplace (think of it as an eBay for time-series data). However, given the difficulties of convincing organizations to share their gold, we pivoted to developing machine learning and IoT technologies for managing Distributed Energy Resources such as solar and storage.",
      logos: mapIcon,
      details:
        "The company’s revenue grew by at least 225% year-on-year from 2015 to 2019. DataGlen has many B2B customers (DISCOMs, OEMs, Solar EPCs and O&Ms) in Australia, New Zealand, Portugal, Kenya, Sri Lanka and India. The company’s products and business models have been recognized with many prestigious awards and honors.",
      imagess: [
        "https://alumni.media.mit.edu/~deva/dataglen/dg2.jpg",
        "https://alumni.media.mit.edu/~deva/dataglen/dg3.jpg",
      ],
      points: `
        <ul class="list-non list-inside text-sm md:text-base p-1">
          <li><span class="text-yellow-500">★</span> In March 2019, NASSCOM, the apex body for the 154 billion dollar Indian IT BPM industry, selected us as one of the winners of NASSCOM’s AI for Good awards.</li>
          <li><span class="text-yellow-500">★</span> In December 2018, Amazon selected DataGlen as the best AI company in the analytics category.</li>
          <li><span class="text-yellow-500">★</span> In July 2018, the best project award for our edge analytics work from Microsoft Research.</li>
          <li><span class="text-yellow-500">★</span> In April 2017, selected as one of the 12 most innovative energy startups in the world by Free Electrons, an energy accelerator program run by 8 global utilities.</li>
          <li><span class="text-yellow-500">★</span> In August 2017, Cisco Launchpad Interstellar award.</li>
          <li><span class="text-yellow-500">★</span> In January 2018, the best startup award from the India Energy Storage Alliance.</li>
          <li><span class="text-yellow-500">★</span> In December 2018, Yes Bank selected DataGlen as one of the 6 startups for 2018 cleantech cohort.</li>
          <li><span class="text-yellow-500">★</span> In August 2017, selected by Karnataka State Government as one of the 100 best startups in Karnataka.</li>
          <li><span class="text-yellow-500">★</span> In February 2019, Government of India selected DataGlen as one of the startups to be featured on Agnii innovation showcase.</li>
          <li><span class="text-yellow-500">★</span> In September 2017, YourStory selected us as one of the 30 best startups.</li>
        </ul>
      `,
      investet: "Currently, the company is being managed by investors.",
      images: [
        "https://alumni.media.mit.edu/~deva/dataglen/dg4.jpg",
        "https://alumni.media.mit.edu/~deva/dataglen/dg5.jpg",
        "https://alumni.media.mit.edu/~deva/dataglen/dg6.jpg",
      ],
    },
  ];

  const toggleAccordion = (id) => {
    setActiveAccordion((prev) => (prev === id ? null : id));
  };

  return (
    <section className="w-[91%] min-h-[1000px] mb-[20%] ml-1 md:ml-2 lg:ml-0  md:mb-2 md:min-h-[1000px]" id="startups">
      <div className="bg-white p-4 md:p-9">
        <div className="max-w-6xl ">
          <div className="mb-12">
            <h2 className="text-xl md:text-2xl font-semibold mb-8">START UPS</h2>
            <div className="accordion">
              {startups.map((startup) => (
                <div key={startup.id} className="border-b border-gray-300 mb-4 pb-4">
                  <button
                    onClick={() => toggleAccordion(startup.id)}
                    className="flex items-center justify-between w-full text-left text-lg font-medium text-gray-800 hover:text-gray-900 focus:outline-none"
                  >
                    <div className="flex items-center w-full  gap-4">
                      <div className="w-[20%]">
                        <img src={startup.logo} alt={startup.alt} className="w-[100%] h-[100%] object-cover" />
                      </div>
                      <div className="w-[78%]">
                        <span className="text-[14px]">{startup.name}</span>
                      </div>
                      <div className="w-[2%]">
                        <span>{activeAccordion === startup.id ? "-" : "+"}</span>
                      </div>
                    </div>
                  </button>

                  {activeAccordion === startup.id && (
                    <div className="mt-4 text-gray-700">
                      <p className="mb-2">{startup.description}</p>
                      <div>
                        {startup.imagess && (
                          <div className="mt-4 grid grid-cols-1 gap-4">
                            {startup.imagess.map((image, index) => (
                              // eslint-disable-next-line jsx-a11y/img-redundant-alt
                              <img
                                key={index}
                                src={image}
                                alt={`Image ${index + 1} of ${startup.name}`}
                                className="h-auto object-contain rounded-md shadow-md"
                              />
                            ))}
                          </div>
                        )}
                      </div>
                      {startup.details && <p className="mb-2">{startup.details}</p>}

                      <div className="mb-2" dangerouslySetInnerHTML={{ __html: startup.points }}></div>
                      <div>
                        <p>{startup.investet} </p>
                      </div>
                      {startup.images && (
                        <div className="mt-4 grid grid-cols-1 gap-4">
                          {startup.images.map((image, index) => (
                            // eslint-disable-next-line jsx-a11y/img-redundant-alt
                            <img
                              key={index}
                              src={image}
                              alt={`Image ${index + 1} of ${startup.name}`}
                              className=" h-auto object-contain rounded-md shadow-md"
                            />
                          ))}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          <div>
            <h2 className="text-xl md:text-2xl font-semibold mb-6">PROJECTS</h2>
            <div className="border border-[#000000] rounded-lg p-8 bg-white">
              <div className="flex justify-center items-center">
                <p className="text-[#707070] text-[25px]">LOADING....</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Startups_Projects;
